import PropTypes from "prop-types";
import styled from "theme/libs/styled";

const Wrapper = styled("div")`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    svg {
        position: relative;
    }

    circle {
        transition: stroke-dashoffset ${({ theme }) => theme.transitions.primarySlow};
        transform: rotate(-90deg);
        transform-origin: 50% 50%;
        position: absolute;

        &:first {
            z-index: 2;
        }
    }
`;

const ChildWrapper = styled("div")`
    position: absolute;
`;

const LevelProgress = ({ percentage, children, backgroundColor, foregroundColor }) => {
    if (percentage > 100) {
        percentage = 100;
    } else if (percentage < 0) {
        percentage = 0;
    }

    const radius = 120;
    const stroke = 10;
    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const offset = circumference - (percentage / 100) * circumference;

    return (
        <Wrapper>
            <svg height={radius * 2} width={radius * 2}>
                <circle
                    stroke={backgroundColor}
                    strokeDasharray={`${circumference} ${circumference}`}
                    strokeDashoffset={0}
                    strokeWidth={`${stroke + 0.5}px`}
                    fill="transparent"
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                />
                <circle
                    stroke={foregroundColor}
                    strokeDasharray={`${circumference} ${circumference}`}
                    strokeDashoffset={offset}
                    strokeWidth={`${stroke}px`}
                    strokeLinecap="round"
                    fill="transparent"
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                />
            </svg>
            <ChildWrapper>{children}</ChildWrapper>
        </Wrapper>
    );
};

LevelProgress.propTypes = {
    percentage: PropTypes.number.isRequired,
    children: PropTypes.element.isRequired,
    backgroundColor: PropTypes.string.isRequired,
    foregroundColor: PropTypes.string.isRequired,
};

export default LevelProgress;
